import Cookie from 'js-cookie';

import { CART_CDC_COOKIE, CART_PCD_COOKIE } from '../settings/cart';
import { getCart } from '../services/cart';

export function getItemCount() {
  return [CART_CDC_COOKIE, CART_PCD_COOKIE]
    .map(name => Cookie.get(name))
    .map(data => +(data || 0))
    .reduce((a, b) => a + b, 0);
}

export const FETCH_CART_ITEMS = 'FETCH_CART_ITEMS';
export const RECEIVE_CART_ITEMS = 'RECEIVE_CART_ITEMS';
export const CART_NOT_LOADED = 0;
export const CART_LOADING = 1;
export const CART_LOADED = 2;
let itemLoadState = CART_NOT_LOADED;
export function fetchCartItems(dispatch) {
  if (itemLoadState === CART_NOT_LOADED) {
    itemLoadState = CART_LOADING;
    dispatch({
      type: FETCH_CART_ITEMS,
      loadState: CART_LOADING
    });
    getCart()
      .then(data => dispatch({
        type: RECEIVE_CART_ITEMS,
        loadState: CART_LOADED,
        data
      }))
      .then(() => itemLoadState = CART_LOADED);
  }
}



// WEBPACK FOOTER //
// ./src/actions/cart.js